import { loading, success, failure } from 'utilities/actions'
import * as actions from './actions'
import type { EnrolmentEntitlement } from 'types'

export type State = {
  data: EnrolmentEntitlement[];
  total: number;
  errors: any[];
  loading: boolean;
  dataFetched: boolean;
};

export type Action = any & {
  type: string;
};

export const initialState: State = {
  data: [],
  total: 0,
  errors: [],
  loading: false,
  dataFetched: false,
}

const reducer = (state: State, action: Action) => {
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case loading(actions.API_ENROLMENT_ENTITLEMENTS_INDEX):
      return { ...state, errors: [], loading: true }
    case success(actions.API_ENROLMENT_ENTITLEMENTS_INDEX):
      return {
        ...state,
        data: action.data,
        total: action.total,
        loading: false,
        dataFetched: true,
        errors: [],
      }
    case failure(actions.API_ENROLMENT_ENTITLEMENTS_INDEX):
      return {
        ...state,
        loading: false,
        errors: action.errors.length ? action.errors : ['Failed to load'],
      }
    default:
      return state
  }
}

export default reducer
